module.exports = __webpack_public_path__ + "static/media/roi-first-appt.459dd98b.png";